import { createRouter, createWebHashHistory } from "vue-router";

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            component: require('@/view/homePage.vue').default,
        },
        {
            path: '/pricing',
            component: require('@/view/pricingPage.vue').default,
        },
        {
            path: '/login',
            component: require('@/view/loginPage.vue').default,
        },
        {
            path: '/download',
            component: require('@/view/downloadPage.vue').default,
        },
        {
            path: '/dynamic',
            component: require('@/view/dynamicPage.vue').default,
        },
    ]
})
export default router;
